import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import * as constants from '../constants'
import type { Plugin } from '../plugin'

/**
 * Applies calculation mode changes to the organization edited under the
 * joint-use current-entity target.
 */
export const updateCalculationMode = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.updateCalculationMode.observe().pipe(
      rxjs.withLatestFrom(
        plugin.collection.plugins.currentEntityPlugin.feature.selectors.getId({
          target: constants.CURRENT_ENTITY_TARGET,
        }).asObservable,
      ),
      rxjs.map(([action, id]) => {
        if (id === undefined) {
          return store.effects.SKIP
        }

        return plugin.collection.plugins.editingPlugin.feature.actions.edit
          .from(action)
          .create({
            id,
            makeCurrent: false,
            edit: organization => {
              if (!organization) {
                return
              }
              organization.jointUseInfo = {
                calculationMode: action.data.calculationMode,
                manualFunctionalizations:
                  organization.jointUseInfo?.manualFunctionalizations,
              }
            },
          })
      }),
    ),
)
